import { ReactComponent as IconChevronDown } from '@/assets/svgs/profile-chevron.svg'
import rem from '@/utils/rem'
import classname from 'classnames'
import React, { useCallback, useRef, useState, useEffect} from "react"
import { Manager, Popper, Reference } from "react-popper"
import MultiClamp from 'react-multi-clamp'
import InputSuffixIcon from "@/components/InputSuffixIcon"
import { ReactComponent as IconSearch } from "@/assets/svgs/icon-search.svg"
import clickCheck from '@/utils/click-check';

const Dropdown = ({ text, value, options = [], error, submit, maxWidth, ghost, full, id, disabled, ...inputProps }) => {

    const [open, setOpen] = useState(false)
    const [label, setLabel] = useState(text)
    const listRef = useRef(null)
    const buttonRef = useRef(null)
    const [myDropdownList, setMyDropdownList] = useState()
    const [prefilledSelectedValue, setPrefilledSelectedValue] = useState("")

    const ddStyles = {
        width: rem(maxWidth)
    }

    const ddClass = classname({
        'dropdown__button': true,
		'dropdown__button--modified': true,
		'dropdown__button--disabled': disabled,
        'dropdown__button--ghost': ghost,
        'dropdown__button--full': full
    })

    useEffect(() => {
		if (options && options.length) {
			const list = options.map((item, index) => {
                return (
                    <div className={'dropdown__item'} onClick={() => onSelect(item) } key={index}>
                        <span title={item.name}>{item.name}</span>
                    </div>
                )
            });
			setMyDropdownList(list);
		}
	}, [options]);

	useEffect(() => {

        const clickCheckCallback = (e) => clickCheck(open, listRef, buttonRef, setOpen, e);

		document.addEventListener('mousedown', clickCheckCallback);

		return () => {
			document.removeEventListener('mousedown', clickCheckCallback);
		}
	}, [open])

    const setButtonRef = useCallback((node, ref) => {
        buttonRef.current = node
        return ref(node)
    }, [])

    const setListRef = useCallback((node, ref) => {
        listRef.current = node
        return ref(node)
    }, [])

    const onToggle = () => {
        setOpen(!open)
    }

    const onSelect = item => {
        setOpen(false)
        setLabel(item.name)
		return submit(item.value)
    }

    // const onFocusOut = () => {
    //     setTimeout(() => setOpen(false), 10)
    // }

    function handleChange(value) {
        setPrefilledSelectedValue(value);
        const userSearchedList = options?.filter((options) => {
            if (options?.name?.toLowerCase().includes(value.toLowerCase())) {
                return true;
            }
            return false;
        });
        const list = userSearchedList.map((item, i) => {
            return (
                <div className={'dropdown__item'} onClick={() => onSelect(item)} key={i}>
                    <span title={item.name}>{item.name}</span>
                </div>
            )
        });
        setMyDropdownList(list);
	}

    return (
        <Manager>
            <Reference>
            {({ ref }) => (
                <div tabIndex="0"
					className={ddClass}
					style={ddStyles}
					ref={node => setButtonRef(node, ref)}
					onClick={() => onToggle()}
					// onBlur={onFocusOut}
					data-testid={id}
					{...inputProps}
				>
                    <div className={(label.includes('Select')) ? 'dropdown__label' : "dropdown__label__selected"}><MultiClamp clamp={1}>{value || label}</MultiClamp></div>
                    <div><IconChevronDown /></div>
                </div>
            )}
            </Reference>
            {open && (
                <Popper
					placement="bottom"
					modifiers={
						[
							{	name: 'preventOverflow',
								enabled: true
							},
							{
								name: 'offset',
								options: {offset: [0,6]}
							}
						]
					}
				>
                    {({ ref, style, placement }) => (
                        <div ref={node => setListRef(node, ref)} style={{ ...style, width: maxWidth, maxWidth }} data-placement={placement}
                            className={`dropdown__list ${(open && "dropdown__list--open") || ""}`}>
                            <div className="search-box-container">
								<InputSuffixIcon
									placeholder={"Search"}
									icon={<IconSearch />}
                                    value={prefilledSelectedValue}
									onChange={(e) => handleChange(e?.target.value)}
								/>
							</div>
                            {myDropdownList}
                        </div>
                    )}
                </Popper>
            )}
        </Manager>
    )
}

export default Dropdown
